/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Mark_As_ReadInputs */

const en_notifications_mark_as_read = /** @type {(inputs: Notifications_Mark_As_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark as read`)
};

const pl_notifications_mark_as_read = /** @type {(inputs: Notifications_Mark_As_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oznacz jako przeczytane`)
};

/**
* | output |
* | --- |
* | "Mark as read" |
*
* @param {Notifications_Mark_As_ReadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const notifications_mark_as_read = /** @type {((inputs?: Notifications_Mark_As_ReadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Mark_As_ReadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_notifications_mark_as_read(inputs)
	return en_notifications_mark_as_read(inputs)
});